import { useQuery } from "@tanstack/react-query";
import TemplatesHandler from "../../../components/admin/messages/TemplatesHandler";
import { getTemplate } from "../../../services/templateServices";

const Templates = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["templates"],
    queryFn: getTemplate,
  });

  if (isLoading)
    return (
      <div className="text-black flex justify-center items-center w-full h-screen">
        Loading templates...
      </div>
    );
  if (error) return <div>Failed to load templates.</div>;

  return <TemplatesHandler template={data?.data} />;
};

export default Templates;
